import {
	UndefinedInitialDataOptions,
	queryOptions
} from '@tanstack/react-query'

import { ReservationDto } from '@wwt/entities/api/search-response'

import { getVoucherQuery } from '../query/getVoucherQuery.ts'

export const getVoucherOptions = (
	reservationId: ReservationDto['reservationId'],
	otherParams: Omit<
		UndefinedInitialDataOptions<Blob>,
		'queryKey' | 'queryFn'
	> = {}
) => {
	return queryOptions<Blob>({
		queryKey: ['voucher', reservationId],
		queryFn: ({ signal }) => getVoucherQuery(reservationId, signal),
		...otherParams
	})
}
